import styled from 'styled-components';

import { LayoutWorkspace } from '@common/layout';
import { ServiceNavigation } from '@components/Workspace/Navigation';
import { Box, Stack } from '@mui/material';
import { State } from '@store/index';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@common/Button';

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  height: calc(100vh - 61px);
  color: ${({ theme }) => theme.text.standard};

  pre {
    margin: 0;
    color: ${({ theme }) => theme.primary};
  }
`;

export const NotFound = () => {
  const navigate = useNavigate();

  const { service_id, other } = useParams();

  const services = useSelector((state: State) => state.flow.services);
  const service = services.find((service) => service.service_id === service_id);

  return (
    <LayoutWorkspace
      header={service?.service_name || 'Workspace'}
      body={
        <Container>
          <ServiceNavigation />
          <Stack>
            <Box p={3} display='flex' alignItems='center' gap={0.8}>
              The page <pre>{other}</pre> is not a valid page.
            </Box>
            <Box p='0 24px'>
              <Button fullWidth onClick={() => navigate(`/${service_id}/workflow`)}>
                Back
              </Button>
            </Box>
          </Stack>
        </Container>
      }
    />
  );
};
